module.exports = __webpack_public_path__ + "img/shovel.be5030ca.webp";